import React from 'react';

import {
  register,
  addMoneyTransfer,
  addMoneyCard,
  addMoneyStore,
  addMoneyAccount,
  addPaymentMethod,
  consultaSaldo,
  envioDinero,
  servicios,
  pagoComercios,
  recarga,
  retiro,
  paquetes
} from '../../../../assets/images';
import { ButtonWhite } from '../../../../components';
import classes from './itemVideo.module.css';

const ItemVideo = props => {
  let image = ({
    'register': register,
    'addMoneyTransfer': addMoneyTransfer,
    'addMoneyCard': addMoneyCard,
    'addMoneyStore': addMoneyStore,
    'addMoneyAccount': addMoneyAccount,
    'addPaymentMethod': addPaymentMethod,
    'consultaSaldo': consultaSaldo,
    'envioDinero': envioDinero,
    'servicios': servicios,
    'pagoComercios': pagoComercios,
    'recarga': recarga,
    'retiro': retiro,
    'paquetes': paquetes,
  })[props.image] || register

  return (
    <div className={classes.itemVideo}>
      <img className={classes.imageItemVideo} src={image} alt="video claro pay" />
      <div className={classes.sectionTitle}>
        <h2 className={classes.title}>{props.title}<br />{props.titleSecondLine}</h2>
        <h3 className={classes.subtitle}>{props.subtitle}</h3>
      </div>
      <ButtonWhite onClick={props.onClick}>
        {props.textButton}
      </ButtonWhite>
    </div>
  )
}

export default ItemVideo;
;